<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col"></div>
</div>

<div class="mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead>
            <tr>
                <th>
                    공지유형
                </th>
                <th>
                    제목
                </th>
                <th style="width: 130px;">
                    등록일시
                </th>
            </tr>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listNotice;">
                <td>
                    {{item.noticeType}}
                </td>
                <td>
                    <button type="button"
                        class="btn btn-sm btn-link px-0 text-info"
                        (click)="clickOpenModalNoticeInfo(DtgActionType.read,item)">
                        {{item.title}}
                    </button>
                </td>
                <td>
                    {{item.updateDt}}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>